import React from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';

function HeadTable(props) {
  const { order } = props;
  const { idOrder } = props;
  const { columns } = props;
  const { setIdOrder } = props;

  return (
    <TableRow>
      {columns.map((column) => (
        <TableCell
          key={column.id}
          align={column.align}
          component="th"
          scope="row"
          style={{ minWidth: column.minWidth, fontWeight: 'bold' }}
        >
          <TableSortLabel
            active={idOrder === column.id}
            direction={order}
            onClick={() => setIdOrder(column.id)}
          >
            {column.label}
            {idOrder === column.id ? (
              <span
                style={{
                  border: 0,
                  clip: 'rect(0 0 0 0)',
                  height: 1,
                  margin: -1,
                  overflow: 'hidden',
                  padding: 0,
                  position: 'absolute',
                  top: 20,
                  width: 1,
                }}
              >
                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
              </span>
            ) : null}
          </TableSortLabel>
        </TableCell>
      ))}
    </TableRow>
  );
}

export default HeadTable;
